import type { CriminalWizardDraft } from '../../../types/criminalCaseRequest';
import { exceedsMax, maxCharLimitExceededError } from '../../../utils/caseFieldValidation';
import type { RequiredErrors } from '../../../utils/requiredValidation';
import { validationDocReasonRequired } from '../../../utils/validationI18n';

export const MAX_DOC_SKIP_REASON = 255;

export const DOC_SKIP_REASON_PLACEHOLDER = 'Enter Reason (Mention if document is not uploaded)';

/** Step 5 — mandatory documents must be uploaded or have a skip reason (max 255 chars). */
export function validateStep5Documents(draft: CriminalWizardDraft): RequiredErrors {
  const errors: RequiredErrors = {};
  draft.documents.forEach((doc) => {
    if (doc.fileName) return;
    if (doc.mandatory && !doc.skipReason.trim()) {
      errors[`doc-reason-${doc.id}`] = validationDocReasonRequired();
      return;
    }
    if (exceedsMax(doc.skipReason, MAX_DOC_SKIP_REASON)) {
      errors[`doc-reason-${doc.id}`] = maxCharLimitExceededError();
    }
  });
  return errors;
}
